import { Box, Flex, Heading, Stack, useColorModeValue } from '@chakra-ui/react'
import * as React from 'react'
import NextImage from 'src/common/NextImage'
import { useAccent3 } from 'src/modeAwareColors'
import { H3 } from 'src/typography/typography'
import ArrowIllustration from './arrowIllustration'
import CollaborateIllustration from './collaborateIllustration'
import { SignupLink } from './links'
import TextBlock from './textBlock'

const Row = props => (
  <Flex
    layerStyle='row'
    justify='space-between'
    {...props}
  />
)

const Builders = () => {
  const a3 = useAccent3()
  const opacity = useColorModeValue(1, 0.2)
  return (
    <Box>
      <H3 color={a3}>
        Projectlink
      </H3>
      <Heading as='h1' textStyle='headline'>
        For builders and suppliers
      </Heading>
      <Row py={20}>
        <TextBlock
          mt='base'
          heading='Projects are added'
          body='We have a team researching and adding new projects monthly. Projectlink alerts you when new projects arrise in your market.'
        />
        <Flex
          mx='auto'
          d={['none', 'none', 'flex']}
        >
          <NextImage
            src='/images/projectlink-notifications.svg'
            dimensions={[210, 216]}
          />
        </Flex>
      </Row>
      <Flex justify={['flex-start', 'flex-start', 'space-around']}>
        <Box
          display={['none', 'none', 'block']}
        >
          <NextImage
            src='/images/triple-arrow.svg'
            dimensions={[168, 631]}
            opacity={opacity}
          />
        </Box>
        <Stack
          spacing={[20, 20, 0]}
          justify='space-around'
        >
          <TextBlock
            heading='View project details'
            body='Project details are posted on our web app.'
          />
          <TextBlock
            heading='Connect directly'
            body='Connect with project owners.'
          />
        </Stack>
      </Flex>
      <Flex
        py={20}
        align='center'
      >
        <TextBlock
          heading='We notify them'
          body='We tell project owners about your company.'
        />
        <Box
          d={['none', 'none', 'block']}
          ml={28}
          mr='auto'
        >
          <NextImage
            src='/images/aggregate-arrow.svg'
            dimensions={[178, 283]}
            opacity={opacity}
          />
        </Box>
      </Flex>
      <Flex
        d={['block', 'block', 'flex']}
        justify='space-around'
        align='center'
      >
        <Box
          maxW='320px'
          pb={[20, 20, 0]}
        >
          <CollaborateIllustration />
        </Box>
        <TextBlock
          heading='Work together'
          body='Share documents, specs, or images. Project information and management is always at your fingertips.'
        />
      </Flex>
      <Flex
        justify='center'
        mx='auto'
        py={28}
      >
        <ArrowIllustration opacity={opacity} />
      </Flex>
      <Heading
        as='h2'
        textStyle='headline'
        textAlign='center'
      >
        Close the deal
      </Heading>
      <Flex justify='center' py={28}>
        <SignupLink />
      </Flex>
    </Box>
  )
}

export default Builders
